module.exports = __webpack_public_path__ + "5a3d6a83.svg";